import { API } from 'src/utils/interceptor'
import { makeOrderResolved } from 'src/features/ReceiptingSlice'
import {
  ASK_FOR_CREDIT_BRIDGE_COPY,
  collectOpenCreditReceiptingIdsFromOrder,
  listOpenCreditReceiptingIdsForPoFromHistory,
} from 'src/utils/askForCreditBridgeHelpers'
import promptCloseCreditRequestAfterApply from 'src/components/invoices/promptCloseCreditRequestAfterApply'
import {
  RejectedNotification,
  SuccessNotification,
} from 'src/notifications/SuccessNotification'

/**
 * After a CN is applied: if the PO has an open Ask-for-credit, confirm close
 * then mark matching credits-history rows resolved. Never silent.
 */
export async function maybePromptAndCloseCreditRequestAfterCnApply({
  dispatch,
  venueId,
  purchaseOrderNumber,
  order = null,
} = {}) {
  const po = String(purchaseOrderNumber || '').trim()
  if (!po) return { prompted: false, closed: false }

  let receiptingIds = collectOpenCreditReceiptingIdsFromOrder(order || {})

  if (!receiptingIds.length && venueId) {
    try {
      const result = await API.get(
        'api',
        `receipting/${venueId}/credits-history?page=1&limit=200`,
      )
      const notes = result?.ordersArr || []
      receiptingIds = listOpenCreditReceiptingIdsForPoFromHistory(notes, po)
    } catch (error) {
      console.error('credits-history lookup failed after CN apply', error)
    }
  }

  if (!receiptingIds.length) {
    return { prompted: false, closed: false }
  }

  const result = await promptCloseCreditRequestAfterApply({
    openCount: receiptingIds.length,
    purchaseOrderNumber: po,
    onConfirm: async () => {
      for (const receiptingId of receiptingIds) {
        // eslint-disable-next-line no-await-in-loop
        await dispatch(makeOrderResolved(receiptingId, venueId))
      }
      SuccessNotification({
        message: ASK_FOR_CREDIT_BRIDGE_COPY.closeSuccess,
        description: `Resolved ${receiptingIds.length} credit ask${
          receiptingIds.length === 1 ? '' : 's'
        } on ${po}.`,
      })
    },
  })

  if (result?.error) {
    RejectedNotification({
      message: 'Could not close credit request',
      description:
        result.error?.message || 'You can mark it resolved on Credit Requests.',
    })
  }

  return {
    prompted: true,
    closed: Boolean(result?.closed),
    receiptingIds,
  }
}
